<template>
    <div class="panel-search" v-bind:class="{ 'dropdown-menu-open': dropDownOpen}" @click.stop="">
        <input type="text"
               :placeholder="placeholder"
               ref="SearchInput"
               :name="name"
               :class="['input-text', {'input-error': hasErrors}]"
               @input="onChangeSearchInput($event)"
               @keydown.enter.prevent=""
               @blur="$emit('blur')"
               @focus="onFocus"
               @focusout="onFocusOut"
               v-model="searchText"
               autocomplete="off"
               :disabled="disabled"
        />
        <div class="dropdown-menu dropdown-list">
            <a
                class="dropdown-menu-item"
                v-for="item of searchResults"
                @click.stop="onSelectResult(item)"
                :style="{'white-space': isMobile ? 'normal' : 'nowrap'}">
                <span v-html="highLightItem(item.Name)"></span>
            </a>
        </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import _ from 'lodash'
    import UI from '../helpers/ui-helpers'

    export default {
        name: "search-filter",

        props: ['name', 'placeholder', 'searchFunction', 'extra', 'selectedItem', 'hasErrors', 'searchOnSelect', 'scrollable', 'disabled', 'fieldName', 'valueItem'],

        $_veeValidate: {
            value () {
                return this.selectedId;
            },
            name () {
                return this.name;
            }
        },

        data() {
            return {
                isMobile: UI.check_mobile(),
                dropDownOpen: false,
                searchResults: [],
                selectedId: null,
                page: 1,
                loading: false,
                canBeLoaded: true,
                searchText: null
            }
        },

        watch: {
            selectedItem: function (newVal, oldVal) {
                let vm = this;
                //console.info('dd -> watch selectedItem changed', vm.selectedItem, vm.selectedId, vm.searchText);
                if (vm.selectedItem && vm.selectedItem.Id > 0 && vm.selectedItem.Name) {
                    //this.$refs.SearchInput.value = vm.selectedItem.Name;
                    this.searchText = vm.selectedItem.Name;
                    this.selectedId = vm.selectedItem.Id;
                }
            },
        },

        methods: {
            highLightItem(itemName) {
                let sText = this.searchText;
                if(this.searchText) {
                    sText = this.searchText.replaceAll('(', '\\(').replaceAll(')', '\\)').replaceAll('.', '\\.');
                }
                //[ ] / { } ( ) * + ? . \ ^ $ |
                return itemName.replace(new RegExp('(' + sText + ')', 'gi'), '<strong>$1</strong>');
            },
            onSelectResult(item) {
                //this.$refs.SearchInput.value = item.Name;
                this.searchText = item.Name;
                this.dropDownOpen = false;

                this.selectedId = item.Id;
                this.$emit('input', this.selectedId);
                //console.info('this.selectedId', item.Name)
                this.$emit('onFilterChange', item, this.extra);
            },

            onFocus() {
                this.$emit('focus');
                let vm = this;

                if (vm.searchOnSelect && !this.selectedId) {
                    vm.searchResults = [];
                    vm.page = 1;
                    vm.loadNext('');
                }
            },

            onFocusOut() {
                let elements = document.querySelectorAll(':hover');
                let elem = elements[elements.length - 1];
                if (elem) {
                    let bFind = elem.tagName.toLowerCase() === 'span' && elem.parentElement.className === 'dropdown-menu-item' ||
                        elem.tagName.toLowerCase() === 'a' && elem.className === 'dropdown-menu-item';
                    if (!bFind)
                        this.dropDownOpen = false;
                } else {
                    this.dropDownOpen = false;
                }
            },

            onChangeSearchInput: _.debounce(function ($event) {
                let vm = this;

                vm.selectedId = null;
                vm.$emit('input', vm.selectedId);
                vm.$emit('onFilterChange', null, this.extra);


                /*if (vm.searchText === '') {
                    vm.dropDownOpen = false;
                    return;
                }*/


                vm.searchResults = [];
                vm.page = 1;
                vm.loadNext();

            }, 500),

            loadNext(){
                let vm = this;

                vm.loading = true;
                vm.searchFunction(vm.searchText, function (res) {
                    console.info('searchFunction', res);
                    if(res && res.length) {
                        if(vm.page === 1) {
                            vm.searchResults = res;
                        }
                        else{
                            for(let item of res){
                                vm.searchResults.push(item);
                            }
                        }
                    }
                    else{
                        vm.canBeLoaded = false;
                    }
                    vm.loading = false;

                }, vm.extra, vm.page, vm.fieldName);

                vm.dropDownOpen = true;
            },
        },

        mounted() {
            let vm = this;
            
            if (vm.selectedItem) {
                //this.$refs.SearchInput.value = vm.selectedItem.Name;
                this.searchText = vm.selectedItem.Name;
                this.selectedId = vm.selectedItem.Id;
            }

            $('body').on('click', function () {
                vm.dropDownOpen = false;
            });

            if(vm.scrollable) {
                vm.$nextTick(() => {

                    //console.info('vm.$el', vm.$el)
                    $(vm.$el).find('.dropdown-menu.dropdown-list').on('scroll', function () {

                        if (!vm.loading && vm.canBeLoaded) {
                            let elem = $(this);
                            if (elem[0].scrollHeight - elem.scrollTop() - 50 <= elem.outerHeight()) {
                                vm.page++;
                                vm.loadNext();
                            }
                        }
                    });
                });
            }
        },

        destroyed(){
            $('.dropdown-menu.dropdown-list').off('scroll');
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// Content/src/components/SearchFilter.vue